import type { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import type { Leasing } from "~/models/Leasing";

export type PropertyRoomOption = {
	// 部屋番号が登録されていないBKK部屋を選択したときnilで保存されるため
	address: string;
	amaterasPropertyId: number | null;
	key: string;
	label: string;
	name: string;
	roomNumber: string | null;
	tenantEmail: string | null;
	// 基本的に部屋のproperty_idが入るが、KT経由で案件作成(駐車場区画を紐づけた契約)した場合、駐車場区画のproperty_idが入る可能性がある
	tenantName: string | null;
	tenantNameKana: string | null;
	tenantTel: string | null;
};

type ComboBoxOption = Exclude<
	ComponentProps<typeof SingleComboBox>["options"][number],
	{ group: string }
>;
type ComboBoxValue = ComponentProps<typeof SingleComboBox>["value"];

export const buildRoomOption = (
	propertyOption: PropertyRoomOption
): ComboBoxOption => ({
	label: propertyOption.label,
	value: propertyOption.key,
	...(propertyOption.key === "manual-input-room" && {
		description: "Tabキー、または、クリックで新規登録"
	})
});

export const roomOptions = (
	propertyOptions: PropertyRoomOption[]
): ComboBoxOption[] => propertyOptions.map(buildRoomOption);

export const propertyRoomOptionValue = (
	propertyOption: PropertyRoomOption | null
): ComboBoxValue => {
	if (propertyOption === null) return null;
	return {
		label: propertyOption.label,
		value: propertyOption.key
	};
};

export const buildPropertyRoomOptionsFromRoomNumber = (
	roomNumber: string
): PropertyRoomOption[] => {
	if (roomNumber === "") return [];

	return [
		{
			address: "",
			amaterasPropertyId: null,
			key: "manual-input-room",
			label: roomNumber,
			name: "",
			roomNumber,
			tenantEmail: null,
			tenantName: null,
			tenantNameKana: null,
			tenantTel: null
		}
	];
};

export const buildPropertyRoomOptionsFromLeasing = (
	leasing: Leasing | null
): PropertyRoomOption | null => {
	if (!leasing?.roomNumber) return null;

	return {
		address: "",
		amaterasPropertyId: leasing.amaterasPropertyId,
		key: `leasing-property-room-${leasing.id}`,
		label: leasing.roomNumber,
		name: "",
		roomNumber: leasing.roomNumber,
		tenantEmail: leasing.tenantEmail,
		tenantName: leasing.tenantName,
		tenantNameKana: leasing.tenantNameKana,
		tenantTel: leasing.tenantTel
	};
};
